export enum SidebarTab {
  SUMMARY = 'Summary',
  ACCOUNT = 'Account',
}
